<template>
  <div>
    <platforms-loader :social-sites:="platforms" @loaded="onLoaded" />
    <q-list class="full-height">
      <q-item
        v-for="(platform) in platforms"
        :key="platform.id"
        class="q-py-lg q-px-md"
        :class="{ 'bg-white': isActive(platform.id) }"
        :clickable="!isActive(platform.id)"
        @click="$emit('update:modelValue', platform)"
      >
        <q-item-section side>
          <platform-icon :social-site="platform" size="2rem" class="on-left" />
        </q-item-section>
        <slot v-bind="{ platform, isActive: isActive(platform.id) }">
          <q-item-section>
            <div class="text-body1" :class="{ 'text-weight-bold': isActive(platform.id) }">
              {{ platform.name }}
            </div>
          </q-item-section>
        </slot>
      </q-item>
    </q-list>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Platform } from '@/social/types';
import PlatformsLoader from './SitesLoader.vue';
import PlatformIcon from './SiteIcon.vue';

interface Data {
  platforms: Platform[]
}

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  components: {
    PlatformIcon,
    PlatformsLoader,
  },
  props: {
    platforms: {
      type: Array as () => Platform[],
      default: () => [],
    },
    modelValue: Object as () => Platform,
  },
  methods: {
    onLoaded(platforms: Platform[]) {
      this.$emit('loaded', platforms);
    },
    isActive(platformId: number): boolean {
      return (this.modelValue && this.modelValue.id === platformId);
    },
  },
});
</script>
